import { render, staticRenderFns } from "./Realnameauth.vue?vue&type=template&id=17d78b0a&scoped=true"
import script from "./Realnameauth.vue?vue&type=script&lang=js"
export * from "./Realnameauth.vue?vue&type=script&lang=js"
import style0 from "./Realnameauth.vue?vue&type=style&index=0&id=17d78b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d78b0a",
  null
  
)

export default component.exports